import { createRouterSelector, getRouterSelectors } from '@ngrx/router-store';

export { ROUTER_NAVIGATED, RouterNavigatedAction } from '@ngrx/router-store';

const routerSelector = createRouterSelector();
export { routerSelector };

export const { selectCurrentRoute, selectRouteParam, selectRouteData } = getRouterSelectors();
